module.exports = __webpack_public_path__ + "img/big-list-02.7ee2aa23.jpg";